import React, { useState, useEffect }  from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import styled from 'styled-components'

import Isotope from "isotope-layout/js/isotope";

import HahnSquares from "../svgs/digital-H-icon.svg"

const IsotopeGrid = () => {

  if (typeof window !== `undefined`) {

    // import Isotope API
    const Isotope = require("isotope-layout/js/isotope");
    
  }

  // init one ref to store the future isotope object
  const isotope = React.useRef()
  // store the filter keyword in a state
  const [filterKey, setFilterKey] = React.useState('*')

  // initialize an Isotope object with configs
  React.useEffect(() => {
      isotope.current = new Isotope('.filter-container', {
      itemSelector: '.filter-item',
      layoutMode: 'fitRows',
      })
      // cleanup
      return () => isotope.current.destroy()
  }, [])

  // handling filter key change
  React.useEffect(() => {
      filterKey === '*'
      ? isotope.current.arrange({filter: `*`})
      : isotope.current.arrange({filter: `.${filterKey}`})
  }, [filterKey])

  const handleFilterKeyChange = key => () => setFilterKey(key)

  const data = useStaticQuery(graphql`
    query {
      workPost: allWpOurWorkProject(
          filter: {caseStudyToggle: {featuredCaseStudy: {eq: true}}}
          sort: {fields: menuOrder, order: ASC}
          ) {
          edges {
              node {
                  title
                  slug
                  featuredImage {
                      node {
                        localFile {
                          childImageSharp {
                            gatsbyImageData(
                              width: 750
                              placeholder: BLURRED
                              formats: [AUTO, WEBP, AVIF]
                            )
                          }
                        }
                      }
                    }
                  categories {
                    nodes {
                      slug
                      name
                    }
                  }
              }
          }
        }
      }
    `)

    const work = data.workPost.edges

    return(
        <>
            <WorkCats>
                <ul class="work-cats">
                <li onClick={handleFilterKeyChange('*')}>All</li>
                <li onClick={handleFilterKeyChange('food-beverage')}>Food + Beverage</li>
                <li onClick={handleFilterKeyChange('energy-essentials')}>Energy + Essentials</li>
                </ul>
            </WorkCats>
            <MainLoop className="filter-container">
                {work.map(post => (
                    <article
                    className={`filter-item ${post.node.categories.nodes.map(category => ( category.slug  )).join(' ')}`}
                    itemScope
                    itemType="http://schema.org/Article"
                    >
                        <Link to={`/work/${post.node.slug}`} itemProp="url" className="work-main-image">
                            <GatsbyImage image={post.node.featuredImage.node.localFile.childImageSharp.gatsbyImageData} alt={post.node.title} />
                            <div class="corner-icon">
                                <HahnSquares/>
                            </div>
                            <div className={`corner-category ${post.node.categories.nodes.map(category => (category.slug))}`}>
                                <p dangerouslySetInnerHTML={{ __html: post.node.categories.nodes.map(category => (category.name)) }} />
                            </div>
                        </Link>
                        <Link to={`/work/${post.node.slug}`}><h2 dangerouslySetInnerHTML={{ __html: post.node.title }} itemProp="headline"/></Link>
                    </article>
                ))}
            </MainLoop>
        </>
    );

}

const WorkCats = styled.div`
  max-width: 1320px;
  width: 100%;
  padding: 0px;
  margin: 0 auto; 
  ul {
    list-style: none;
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    margin-bottom: 15px;
    li {
      margin-left: 10px;
      margin-right: 10px;
      margin-bottom: 0px;
      font-family: "Work Sans";
      color: #fff;
      text-transform: uppercase;
      font-size: 12px;
      font-weight: 700;
      letter-spacing: 1.2px;
      line-height: 1;
      padding: 10px 20px;
      &:nth-child(1) {
        background-color: #E4CA5B;
      }
      &:nth-child(2) {
        background-color: #6D9840;
      }
      &:nth-child(3) {
        background-color: #3A5DAE;
      }
      &:hover {
        cursor: pointer;
      }
    }
  }
  @media(max-width:1000px) {
    max-width: 700px;
    ul {
      justify-content: center;
      li {
        margin-left: 10px;
        margin-right: 10px;
      }
    }
  }
  @media(max-width:767px) {
    max-width: 500px;
    ul {
      flex-wrap: wrap;
      li {
        text-align: center;
        padding: 10px;
        margin: 10px;
      }
    }
  }
`

const MainLoop = styled.section`
    max-width: 1350px;
    width: 100%;
    margin: 60px auto;
    margin-top: 0px;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    article {
        width: 50%;
        padding: 15px;
        .work-main-image {
          position: relative;
          display: block;
        }
        .corner-icon {
          position: absolute;
          width: 150px;
          top: 0;
          right: 0;
        }
        .corner-category {
          position: absolute;
          bottom: 0;
          right: 0;
          padding: 10px 20px;
          &.food-beverage {
            background-color: #6D9840;
          }
          &.energy-essentials {
            background-color: #3A5DAE;
          }
          p {
            color: #fff;
            text-transform: uppercase;
            font-size: 12px;
            font-weight: 700;
            letter-spacing: 1.2px;
            line-height: 1;
          }
        }
        a {
            text-decoration: none;
            color: #2b2520;
            > div.gatsby-image-wrapper {
                height: 475px;
                width: 100%;
                background-color: #aaa;
            }
        }
        h2 {
            font-family: "Nobel",sans-serif;
            font-size: 30px;
            line-height: 34px;
            font-weight: 700;
            color: #2b2520;
            margin-top: 10px;
            margin-bottom: 5px;
            transition-duration: .3s;
        }
        p {
            font-family: "Work Sans";
            font-size: 14px;
            line-height: 20px;
            font-weight: 400;
            color: #444;
            margin-top: 0;
            margin-bottom: 0px;
        }
        img {
          transition: opacity 500ms ease 0s, transform 1s 0s !important;
        }
        &:hover {
          img {
            transform: scale(1.1);
          }
          h2 {
            color: #C44C4A;
          }
        }
    }
    @media(max-width:1000px) {
      max-width: 700px;
      article {
        width: 100%;
      }
    }
    @media(max-width: 767px) {
      max-width: 500px;
      margin-top: 20px;
      article {
        .corner-icon {
          width: 75px;
        }
        a {
          > div.gatsby-image-wrapper {
            height: 275px;
          }
        }
        h2 {
          font-size: 24px;
          line-height: 1.2;
        }
      }
    }
`

export default IsotopeGrid